/*
 * Project: forca
 * File Created: Friday, 22nd October 2021 2:36:30 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

/* eslint-disable @typescript-eslint/ban-ts-comment */
/*
 * Project: forca
 * File Created: Friday, 22nd October 2021 2:08:50 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React, { Component } from 'react';

import OptionButtonsComponent from './OptionButtons.component';
import { Option } from './optionButtons.definition';

class OptionButtonsContainer extends Component<any> {
	containerProps(): {options: Option[], button: string} {
		const { currentBlock = null } = this.props;

		if (!currentBlock) {
			return null;
		}

		const {
			buttonLinkFirst,
			buttonLinkSecond,
			currentBlock: {
				iconFirst,
				iconSecond,
				svgIconFirst,
				svgIconSecond,
				titleFirst,
				titleSecond,
				contentFirst,
				contentSecond,
				button
			}
		} = this.props;

		return {
			options: [
				{
					icon: iconFirst,
					svgIcon: svgIconFirst,
					title: titleFirst,
					content: contentFirst,
					link: buttonLinkFirst
				},
				{
					icon: iconSecond,
					svgIcon: svgIconSecond,
					title: titleSecond,
					content: contentSecond,
					link: buttonLinkSecond
				}
			],
			button
		};
	}

	render() {
		return (
			<>
				{ /* @ts-ignore */ }
				<OptionButtonsComponent
					{ ...this.containerProps() }
				/>
			</>
		);
	}
}

export default OptionButtonsContainer;